<template>
    <div>
        <div class="neue fsp20 lh28 text-black d-flex justify-content-between align-items-center" :class="{ 'mb32': this.isMobile, 'mb16': !this.isMobile }">
            <div v-if="this.isMobile">
                <Icon name="arrow-left" class="c24 pointer" @click="this.close()"/>
            </div>
            <div class="flex-grow-1 fsp20 lh28" :class="{ 'text-center mr24': this.isMobile }">
                {{ this.$store.state.modal.content.title }}
            </div>
            <div v-if="!this.isMobile">
                <Icon name="close" class="c24 pointer" @click="this.close()"/>
            </div>
        </div>
        <div class="p24 mb-0" :class="!this.isMobile ? 'content' : ''">
            <div class="d-flex flex-column gap16">
                <div class="neue-roman fsp14 lh20 text-black">
                    <div class="mb16">
                        {{ this.$t('views.P2P.SingleSwap.52') }} {{ this.$store.state.modal.content.time }} {{ this.$t(`views.P2P.SingleSwap.${this.timeKey}`) }}
                    </div>
                    <div>{{ this.$t('views.P2P.SingleSwap.53') }}</div>
                </div>
            </div>
            <div class="d-flex mt24" :class="{ 'position-fixed bottom-0 left-0 end-0 py16 px24 w-100 border-t bg-white': this.isMobile }">
                <Button type="btn-warning" class="equal-width h48 mr16 border-full" @click="this.save()">
                    {{ $t('views.P2P.SingleSwap.54') }}
                </Button>
                <Button type="btn-outline-grey" class="equal-width h48 primary-grey" @click="this.clearAll()">
                    {{ $t('views.P2P.SingleSwap.55') }}
                </Button>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/icons/Icon'
import Button from '@/components/service/Button'


export default {
    name: 'ExtendP2PTimer',
    components: {
        Icon,
        Button,
    },
    props: {
        close: {
            type: Function,
            required: true
        }
    },
    computed: {
        isMobile() {
            return this.$store.state.isMobile
        },
        timeKey() {
            const time = parseInt(this.$store.state.modal.content.time);
            return time === 1 ? '95' : '94';
        }
    },
    methods: {
        save() {
            if (this.$store.state.modal.content.callback) {
                this.$store.state.modal.content.callback();
            }
            this.close();
        },
        clearAll() {
            this.close();
        }
    }
}


</script>
